/**
 * Created by yougen.zhuangyg on 2015/1/5.
 */
   var Token = {};
   Token.getToken = function(){
       var cookie = document.cookie;
       var match = cookie && cookie.match(/(?:^|;)\s*xman_us_t\s*=\s*([^;]+)/);
       if(match){
           match = match[1].match(/(?:^|&)\s*ctoken\s*=\s*([^&]+)/);
       }
       var ret = (match && match[1]);
       if(!ret){
           if(window.dmtrack){
               dmtrack.dotstat(17780,{},true);
           }
       }
       return ret;
   };
   module.exports = Token;
